<template>
  <q-card flat bordered style="width:100%">
    <q-card-section>
        <h4 class="text-positive text-center q-mt-lg q-mb-xs">
            This order has been placed. Thank you!
        </h4>
        <div class="border-brand6 heading-text">
            <div
            class="text-bold text-brand7 text-center">
            If you have any more questions, please call us
            <span class="text-brand5 dialable-box" @click="$emit('dialPhone')">
                {{callNumberDisplay}}
            </span>
            </div>
            <h6 class="text-center">
                For future reference your order ID is
                <span class="text-primary text-order-number"> {{orderId}}</span>
            </h6>
            <div class="mt-md">
                <h6 class="text-center">
                    A <span class="text-brand5">Router Runner's</span> {{contactInfoText}}
                </h6>
            </div>

        </div>
        <section class="section section-how-it-works q-py-lg q-px-xl">
            <div class="container">
                <div class="row mt-5">
                    <div class="col-12 col-md-6 p-5">
                        <q-img  fit="contain" class="rr-icon mb-5 video-overlay" v-if="!playingVideo" @click="playingVideo = !playingVideo" id="video-overlay-1" src="https://www.routerunnersautotransport.com/images/rr-video.jpg" alt="Route Runners Video" />
                            <div class="embed-responsive mb-5" v-if="playingVideo">
                            <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/emba9HyQZ10?rel=0&autoplay=1"></iframe>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 q-pa-lg">
                        <h3 class="text-center">How it works</h3>

                        <p class="" style="font-size:22px">
                            {{guideText}}
                            <br>
                            <img width="120px" align="right"  src="https://www.routerunnersautotransport.com/assets/images/Mascot_02.svg" alt="Route Runners quote" />
                        </p>
                    </div>
                    <div class="col-md-12 col-12 q-mt-xl q-px-xl">
                        <q-img  fit="contain" src="https://www.routerunnersautotransport.com/images/images/how-it-works.jpg" class="rr-icon q-mb-lg" alt="Route Runners How it Works Process" />

                        <hr class="bg-brand5" style="height:6px">
                    </div>
                </div>
            </div>
            <!--container-->
        </section>
    </q-card-section>
  </q-card>
</template>

<script>
export default {
  name: 'AppOrderBookedCard',
  props: {
    callNumberDisplay: String,
    orderId: Number
  },
  components: {
  },
  data() {
    return {
        playingVideo: false,
        guideText: 'Take a look at our 5 step guide to 5-star transport! We can ship your car anywhere in the country with these simple steps. Feel free to reach out to us with any questions!',
        contactInfoText: 'shipping agent will contact you when we dispatch/schedule the driver for your vehicle.'
    };
  },
  methods: {

  }
};
</script>
<style lang="scss">

.embed-responsive::before {
    display: block;
    content: "";
    padding-top: 56.25%;
}
    .embed-responsive {
        position: relative;
    }
    .embed-responsive-item {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
    .text-order-number {
        font-size: 1.4em;
    }
</style>
